import {environment} from '../../environments/environment';
import { Injectable } from "@angular/core";

@Injectable()
export class ApiRoutes {
  readonly TRANSLATION: string = environment.apiUrl + 'api/translations/';
  readonly REFRESH_TOKEN: string = environment.apiUrl + 'backend/token/refreshToken';
  readonly ERROR_LOG: string = environment.apiUrl + 'api/errorHandler';
  readonly ISSUE_SUMMARY: string = environment.apiUrl + 'api/issue/{0}/summary';
  readonly ISSUES: string = environment.apiUrl + 'api/issue';
  readonly ISSUE_ACTIONS: string = environment.apiUrl + 'api/action/issue/{0}';
  readonly ISSUE_LOGS: string = environment.apiUrl + 'api/issue/{0}/log';
  readonly ISSUE_RESOLVE: string = environment.apiUrl + 'api/issue/{0}/resolve';
  readonly ISSUE_MEDIA: string = environment.apiUrl + 'api/multimedia/issue/{0}';
  readonly ACTIONS: string = environment.apiUrl + 'api/action';
  readonly ACTION_DETAILS: string = environment.apiUrl + 'api/action/{0}';
  readonly ACTION_LOGS: string = environment.apiUrl + 'api/action/{0}/logs';
  readonly ACTION_ISSUES: string = environment.apiUrl + 'api/action/{0}/issues';
  readonly ACTION_MEDIA: string = environment.apiUrl + 'api/multimedia/action/{0}';
  readonly ACTION_ASSIGN: string = environment.apiUrl + 'api/action/assignAction';
  readonly ACTIONS_ASSIGN: string = environment.apiUrl + 'api/action/assignActions';
  readonly ACTION_UNASSIGN: string = environment.apiUrl + 'api/action/{0}/interventionTeam';
  readonly ACTIONS_DELETE: string = environment.apiUrl + 'api/action/deleteActions';
  readonly ACTIONS_COMPLETE: string = environment.apiUrl + 'api/action/completeActions';
  readonly ACTION_SEND_ALL: string = environment.apiUrl + 'api/action/sendAllActions/{0}';
  readonly ACTION_DELETE: string = environment.apiUrl + 'api/action/{0}';
  readonly ACTION_PRIORITIZE: string = environment.apiUrl + 'api/action/prioritizeAction';
  readonly ACTION_UPDATE_WORKORDERREFERENCE: string = environment.apiUrl + 'api/action/{0}';
  readonly ACTION_SEND_NOTIFICATION: string = environment.apiUrl + 'api/action/actionSentNotification/{0}';
  readonly BUILDINGS: string = environment.apiUrl + 'api/building';
  readonly BUILDINGS_FOR_INTERVENTION_TEAM: string = environment.apiUrl + 'api/building/interventionteam/{0}';
  readonly INTERVENTION_TEAMS: string = environment.apiUrl + 'api/interventionTeams';
  readonly INTERVENTION_TEAMS_SUMMARIES: string = environment.apiUrl + 'api/interventionTeams/summaries';
  readonly INTERVENTION_TEAMS_SEARCH: string = environment.apiUrl + 'api/interventionTeams/search';
  readonly INTERVENTION_TEAMS_DEFAULTS_FOR_BUILDING: string = environment.apiUrl + 'api/interventionTeams/defaultsforbuilding/{0}';
  readonly INTERVENTION_TEAM: string = environment.apiUrl + 'api/interventionTeams/{0}';
  readonly INTERVENTION_TEAM_BUILDING: string = environment.apiUrl + 'api/interventionTeams/{0}/building/{1}';
  readonly INTERVENTION_TEAM_CONTACT: string = environment.apiUrl + 'api/interventionTeams/{0}/contact/{1}';
  readonly CONTACTS: string = environment.apiUrl + 'api/contact';
  readonly CONTACTS_SEARCH: string = environment.apiUrl + 'api/contact/search';
  readonly CONTACT: string = environment.apiUrl + 'api/contact/{0}';
  readonly CONTACT_INVITE_TO_JOBS: string = environment.apiUrl + 'api/contact/{0}/InviteToJobs';
  readonly LANGUAGES: string = environment.apiUrl + 'api/translations/availableLanguages';
  readonly INTERVENTIONS_BUSINESS_RULES: string = environment.apiUrl + 'api/interventions/businessRules';
  readonly LOGIN: string = environment.apiUrl + 'api/login';
  readonly LOGIN_DETAILS: string = environment.apiUrl + 'api/login/{0}';
  readonly LOGIN_INVITE: string = environment.apiUrl + 'api/login/{0}/invite';
  readonly LOGIN_VALIDATE_USERNAME: string = environment.apiUrl + 'api/login/usernameValidation';
  readonly APPLICATIONS_ROUTE = environment.accountSiteUrl + 'api/applications';
  readonly LOGIN_AND_AGREE_LICENSE: string = environment.apiUrl + 'api/license/agreeToLicense';
  readonly UPDATE_PASSWORD_AND_AGREE_LICENSE: string = environment.apiUrl + 'account/updatePassword';
  readonly AGREE_LICENSE: string = environment.apiUrl + 'api/license/agreeLicense/{0}';
  readonly GET_LOGIN_BY_CONFIRMATION_CODE: string = environment.apiUrl + 'account/login/{0}';
  readonly MANIFEST: string = environment.apiUrl + 'api/manifest/{0}';
  readonly STRUCTURE: string = environment.apiUrl + 'api/structure';

  public static getRouteWithInjectedParams(route: string, values: string[]): string {
    let result: string = route;
    for (let i = 0; i < values.length; i++) {
      result = result.replace(`{${i}}`, values[i]);
    }
    return result;
  }
}
